import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { experienceApi } from "@/lib/api";

type AppConfig = {
  enginePublicUrl: string;
  /** Where operators manage their account; null outside Arcade Cloud. */
  accountUiUrl?: string | null;
  sessionInspectorEnabled?: boolean;
  /** The chart version on a self-hosted install; null on Arcade Cloud. */
  version?: string | null;
};

export const appConfigQueryOptions = () =>
  queryOptions<AppConfig>({
    queryKey: ["config", "app"],
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: async () => {
      const { data } = await experienceApi.get<AppConfig>("/api/config/app");
      return data;
    },
  });

export function useEnginePublicUrl(): string {
  const { data } = useSuspenseQuery(appConfigQueryOptions());
  return data.enginePublicUrl;
}
